import { DARK_BLUE } from "theme/colors";

function createDefinition(
  color: string,
  fontSize: number,
  lineHeight: number,
  fontWeight: number,
  letterSpacing: number
) {
  const relativeLineHeight = lineHeight / fontSize;
  return {
    color,
    fontSize,
    lineHeight: relativeLineHeight,
    fontWeight,
    letterSpacing,
  };
}

export const Definitions = {
  h1: createDefinition(DARK_BLUE[100], 36, 40, 900, 0.15),
  h2: createDefinition(DARK_BLUE[100], 28, 31, 700, 0.1),
  h3: createDefinition(DARK_BLUE[100], 22, 24, 700, 0.1),
  h4: createDefinition(DARK_BLUE[100], 18, 20, 700, 0.1),
  h5: createDefinition(DARK_BLUE[100], 18, 28, 700, 0.1),
  h6: createDefinition(DARK_BLUE[100], 18, 28, 500, 0.1),
  h7: createDefinition(DARK_BLUE[100], 18, 28, 500, 0.1),
  overline1: createDefinition(DARK_BLUE[100], 14, 14, 900, 1.25),
  overline2: createDefinition(DARK_BLUE[100], 12, 12, 900, 0.75),
  overline3: createDefinition(DARK_BLUE[100], 10, 16, 900, 0.5),
  caption1: createDefinition(DARK_BLUE[100], 12, 16, 500, 0.75),
  caption2: createDefinition(DARK_BLUE[100], 12, 16, 700, 0.75),
  subtitle1: createDefinition(DARK_BLUE[100], 14, 16, 500, 0),
  subtitle2: createDefinition(DARK_BLUE[100], 14, 16, 700, 0),
  subtitle3: createDefinition(DARK_BLUE[100], 12, 20, 500, 0),
  body1: createDefinition(DARK_BLUE[100], 16, 20, 500, 0),
  body2: createDefinition(DARK_BLUE[100], 16, 20, 500, 0),
  body_bold: createDefinition(DARK_BLUE[100], 16, 20, 700, 0),
  body_thin: createDefinition(DARK_BLUE[100], 16, 22.4, 300, 0),
  body_small: createDefinition(DARK_BLUE[100], 14, 20, 500, 0.1),
  label: createDefinition(DARK_BLUE[100], 12, 16, 500, 0.1),
  label_bold: createDefinition(DARK_BLUE[100], 12, 16, 700, 0.1),
  label_small: createDefinition(DARK_BLUE[50], 11, 11, 400, 0),
};
